import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-3 mb-3 sticky left-0" }
const _hoisted_2 = { class: "grow flex flex-col border-b-2 border-white" }
const _hoisted_3 = { class: "flex items-center gap-3 flex-grow pr-3" }
const _hoisted_4 = ["disabled", "value"]
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "text-sm flex items-center border-b-2 border-white gap-3 px-2" }
const _hoisted_8 = { class: "flex justify-center sticky left-0 mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SezioneHead = _resolveComponent("SezioneHead")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("i", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:expanded', !_ctx.expanded))),
            class: _normalizeClass(["icon-chevron_giu h-4 cursor-pointer transition ease-linear duration-100 transform-gpu", {'-rotate-90': !_ctx.expanded}])
          }, null, 2),
          _createElementVNode("input", {
            disabled: _ctx.readonly,
            value: _ctx.titolo,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:titolo', $event.target.value))),
            type: "text",
            class: "bg-transparent text-xl flex-grow",
            placeholder: "Nuova sezione"
          }, null, 40, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.hideTotal)
            ? (_openBlock(), _createBlock(_component_SezioneHead, {
                key: 0,
                totaleCosti: _ctx.totaleCosti,
                budgetProgetto: _ctx.budgetProgetto,
                primoMarigne: _ctx.primoMarigne,
                fee: _ctx.fee,
                primoMarignePerc: _ctx.primoMarignePerc,
                class: "w-1/2"
              }, null, 8, ["totaleCosti", "budgetProgetto", "primoMarigne", "fee", "primoMarignePerc"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "tooltip-activator relative flex items-center cursor-pointer hover:text-next-orange mr-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clickDuplicaSezione')))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "icon-duplica h-4 px-2" }, null, -1)),
              _createVNode(_component_Tooltip, { class: "-translate-y-1.5" }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Duplica")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("span", {
              class: "tooltip-activator relative flex items-center cursor-pointer hover:text-next-orange mr-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clickAggiungiSezione')))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "icon-croce_cerchiata h-4 px-2" }, null, -1)),
              _createVNode(_component_Tooltip, { class: "-translate-y-1.5" }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Aggiungi sezione")
                ])),
                _: 1
              })
            ]),
            _createVNode(_component_ConfirmDelete, {
              readonly: !_ctx.$attrs['deletable'] || _ctx.readonly,
              onCancella: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancella'))),
              position: "left",
              class: "px-2"
            }, null, 8, ["readonly"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("i", {
                class: _normalizeClass(["icon-chevron_destra cursor-pointer -rotate-90", [_ctx.first ? 'invisible': 'visible']]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('orderUp')))
              }, null, 2),
              _createElementVNode("div", null, _toDisplayString(_ctx.order), 1),
              _createElementVNode("i", {
                class: _normalizeClass(["icon-chevron_destra cursor-pointer rotate-90", [_ctx.last ? 'invisible': 'visible']]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('orderDown')))
              }, null, 2)
            ])
          ], 512), [
            [_vShow, !_ctx.readonly]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{'max-h-0 overflow-hidden': !_ctx.expanded}, "transition transform-gpu"])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", {
        class: "flex items-center cursor-pointer hover:text-next-orange mr-2",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('clickAddRow')))
      }, _cache[12] || (_cache[12] = [
        _createElementVNode("i", { class: "icon-croce_cerchiata h-4 px-2" }, null, -1),
        _createTextVNode(" Agg. Riga ")
      ]))
    ], 512), [
      [_vShow, !_ctx.readonly]
    ])
  ], 64))
}